export default ({ data }) => {
  let { title, orderText, template, paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft, } = data;

  if (template) {
    template = template.replace("{{title}}", title).replace("{{orderText}}", orderText);
  }

  return (
    <div>
      {!!template ? (
        <section
          style={{
            paddingTop,
            paddingBottom,
            paddingRight,
            paddingLeft,
          }}
          dangerouslySetInnerHTML={{ __html: template }}
        ></section>
      ) : (
        <div>Default WeChat Header Block</div>
      )}
    </div>
  );
};
